<template>
  <div class="footer">
    <div class="w">
      <div class="top">
        <div class="top-left">
          <div class="top-left-logo">
            <img src="../assets/img/dulles/footer-logo.png" alt="" />
          </div>
          <div class="top-left-sm-logo">
            <el-popover placement="top" width="176" trigger="hover">
              <div
                style="
                  text-align: center;
                  font-size: 14px;
                  margin: 16px 0 12px;
                  font-weight: bold;
                "
              >
                杜勒斯微信公众号
              </div>
              <div style="text-align: center">
                <img
                  :src="getImageURL(list.officialAccountUrl)"
                  style="width: 160px; height: 160px"
                />
              </div>
              <img
                slot="reference"
                src="../assets/img/dulles/logo-w.png"
                alt=""
              />
            </el-popover>
            <el-popover placement="top" width="176" trigger="hover">
              <div
                style="
                  text-align: center;
                  font-size: 14px;
                  margin: 16px 0 12px;
                  font-weight: bold;
                "
              >
                杜勒斯微信视频号
              </div>
              <div style="text-align: center">
                <img
                  :src="getImageURL(list.videoUrl)"
                  style="width: 160px; height: 160px"
                />
              </div>
              <img
                slot="reference"
                src="../assets/img/dulles/logo-s.png"
                alt=""
              />
            </el-popover>
            <el-popover placement="top" width="176" trigger="hover">
              <div
                style="
                  text-align: center;
                  font-size: 14px;
                  margin: 16px 0 12px;
                  font-weight: bold;
                "
              >
                杜勒斯抖音号
              </div>
              <div style="text-align: center">
                <img
                  :src="getImageURL(list.tiktokUrl)"
                  style="width: 160px; height: 160px"
                />
              </div>
              <img
                slot="reference"
                src="../assets/img/dulles/logo-d.png"
                alt=""
              />
            </el-popover>
            <el-popover placement="top" width="176" trigger="hover">
              <div
                style="
                  text-align: center;
                  font-size: 14px;
                  margin: 16px 0 12px;
                  font-weight: bold;
                "
              >
                杜勒斯小红书
              </div>
              <div style="text-align: center">
                <img
                  :src="getImageURL(list.redBookUrl)"
                  style="width: 160px; height: 160px"
                />
              </div>
              <img
                slot="reference"
                src="../assets/img/dulles/logo-x.png"
                alt=""
              />
            </el-popover>
          </div>
        </div>
        <div class="top-right">
          <div class="contact-us">
            <el-popover placement="top" width="176" trigger="hover">
              <div
                style="
                  text-align: center;
                  font-size: 14px;
                  margin: 16px 0 12px;
                  font-weight: bold;
                "
              >
                杜勒斯官方企业微信
              </div>
              <div style="text-align: center">
                <img
                  :src="getImageURL(list.webchatUrl)"
                  style="width: 160px; height: 160px"
                />
              </div>
              <span slot="reference">联系我们</span>
            </el-popover>
          </div>
          <div class="contact-info">
            <span>服务热线：{{list.hotline}}</span>
            <span class="text">联系邮箱：{{list.email}}</span>
          </div>
          <div class="address">
            <span>总部地址：{{list.companyAddress}}</span>
            <span class="text">工厂地址：{{list.factoryAddress}}</span>
          </div>
        </div>
      </div>
      <div class="solid"></div>
      <div class="bottom">
        <!-- 2024©杜勒斯官网｜鲁ICP备18044575号-4｜鲁公安备37028202000811｜青岛杜勒斯玻璃有限公司 -->
      </div>
    </div>
  </div>
</template>
 
<script>
import { baseURL } from '../utils/index.js';
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      list:{}
    };
  },
  created() {},
  computed: {},
  mounted() {
    this.search()
  },
  methods:{
     getImageURL(image) {
      return baseURL + image;
    },
    // 查询
    search(){
      this.list = {}
      this.$http.get(`company/get`).then((res) => {
        if (res.data.code == 'success') {
        this.list = res.data.data
        }
      });
    }
  }
};
</script>
 
<style lang="scss" scoped>
.footer {
  background: #907159;
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 50px 115px 40px;
    .top-left {
      width: 21.5%;
      .top-left-logo {
      }
      .top-left-sm-logo {
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        align-content: center;
      }
    }
    .top-right {
      width: 70%;
      color: #ffffff;
      .contact-us {
        font-size: 16px;
      }
      .contact-info {
        font-size: 14px;
        margin: 16px 0 12px;
      }
      .address {
        font-size: 14px;
      }
      .text {
        margin-left: 60px;
      }
    }
  }
  .solid {
    width: 100%;
    height: 2px;
    background: #ffffff;
  }
  .bottom {
    padding: 40px 0;
    text-align: center;
    color: #664f3e;
  }
}
</style>